import HeroSection from "./home/HeroSection";
import MissionSection from "./home/MissionSection";
import ApproachSection from "./home/ApproachSection";
import PartnersSection from "./home/PartnersSection";
import TestimonialsSection from "./home/TestimonialsSection";
import FAQSection from "./home/FAQSection";
import ClosingCTASection from "./home/ClosingCTASection";

export default function Home() {
    return (
        <div data-testid="home-page">
            <HeroSection />
            <MissionSection />
            <ApproachSection />
            <PartnersSection />
            <TestimonialsSection />
            <FAQSection />
            <ClosingCTASection />
        </div>
    );
}
